import useMutationRoleCreateUpdate from './role-use-mutation-create-update';
import useMutationRoleDelete from "./role-use-mutation-delete";


export const roleUseMutation = {
  createUpdate: useMutationRoleCreateUpdate,
  delete: useMutationRoleDelete,
}